import vDrag from "./vDrag.js";
import vOnresize from "./vOnresize.js";

function install(Vue) {
  Vue.use(vDrag);
  Vue.use(vOnresize);
}

export default install;